// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sub-title[data-v-329a1ff2]{\n  height:50px;\n  text-align:center;\n  line-height:50px;\n}\n", ""]);
// Exports
module.exports = exports;
